export const SET_SHOW_DIALOG_PAYMENT_INFO_RECHARGE =
  'SET_SHOW_DIALOG_PAYMENT_INFO_RECHARGE'
export const SET_IS_RETRY_BTN_CLICKED = 'SET_IS_RETRY_BTN_CLICKED'
export const SET_IS_RENEW_BTN_CLICKED = 'SET_IS_RENEW_BTN_CLICKED'
export const SET_IS_RENEW_DECLINED = 'SET_IS_RENEW_DECLINED'
